
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyButton as SkyButtonElement } from '@sky.ui/core/sky-button';
 
 
 
 

 
 export const SkyButton = createComponent({
   displayName: 'SkyButton',
   react: React,
   tagName: 'sky-button',
   elementClass: SkyButtonElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-button';
